// extracted by mini-css-extract-plugin
export default {"wrapper":"titles-slot_wrapper__WoDCR","mobile":"titles-slot_mobile__WeKkJ","responsive":"titles-slot_responsive__N9b5U","content-fade":"titles-slot_content-fade__pM0MG"};